import { render, staticRenderFns } from "./Fairs.vue?vue&type=template&id=4a020ba5&"
import script from "./Fairs.vue?vue&type=script&lang=js&"
export * from "./Fairs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports